var Raphael = require('raphael'),
    _ = require('underscore'),
    BaseShape = require('../baseShape'),
    ShapeUtils = require('../shapeUtils');

/*
* 'Coordinate' implies zones peristed in fdd.graphic_object files on EDSTOR.
*  They are rendered from coordinate/points, unlike Doc Viewer SVG note types.
* */

module.exports = BaseShape.extend({

    /*
    * seeThroughFill: 'color' stored in Edstor Zone files
    * subtype: 'RECTANGLE' or 'POLYGON'; really only applicable for redactions but write to Edstor file for the other types
    *   - ( highlight, strikeThrough ) for consistency with FDD and future flexibility in case we ever utilize the value
    *   - note: not used in this app except for persisting to the appropriate file ( it's derived from points ... would have made things
    *   - much easier if this was passed down to me from the backend in the first place ....
    * */
    defaults: function() {

        return _.extend( {}, BaseShape.prototype.defaults.apply( this, arguments ), {
            points: null,
            seeThroughFill: null,
            subtype: null
        });

    },
    /*
    *  TODO: when refactor this to defaults instead ( and move away from parse to constructor --  should be clearer )
    * */
    setZoneColorOnParse: function( attrs, options ) {

        var defaultNoteShapeColor = options.parentNote.getDefaultShapeColor();

        var color = !options.isNewlyDrawn
            ? attrs.seeThroughFill
                ? attrs.seeThroughFill
                : defaultNoteShapeColor // ( handle modification of notes with shapes created before seeThroughFill )
            : defaultNoteShapeColor;

        this.setZoneColor( color );

    },

    getNonPathActiveSVGAttrs: function( canvasChannel ) {

        var attrs = canvasChannel.request( 'getAttributesToApplyToShapeEl', this.parentNote, true, this );

        // TODO: subclass
        if ( this.isFindAndRedactShape ) {

            attrs['stroke-width'] = 1; // like the smaller stroke width
            // defaultNoteLevelAttrs['stroke-dasharray'] = '-'; // this is the best but kinda distracting ... may be better to utitlize if selected
            // eh but could run into conflict ...
            // maybe no fill at all - this could also help with overlap issue (if that comes back)
            // green makes red look like watermelon
            // want different color to distinqush from regular active notes
            // '#3399FF'; same color as textEditBtn.js -- doesn't look good -- too light
            attrs.stroke = 'blue';

            // actually I kind of like this ... but it's not as noticable; looks better with dash array and with a consistent border stroke
            // but don't have no b/c then can't click
            // defaultNoteLevelAttrs.fill = 'none' -- so you fill opacity
            // ** side effect is you don't see the 'preview' -- eg if you sent consult color or whatever **
            //defaultNoteLevelAttrs['fill-opacity'] = 0;

            if ( this.uiModel.get('isHitApplied') ) {
                attrs.stroke = '#35aa47'; // now same green as apply button
            }
            // would need to redo glow on this when change the color's
        }

        return attrs;

    },

    /*
    * This applies to non-redaction -- will be overwritten
    * For now we aren't working with zone color so all will have the same (that's why this is at the note level).
    * this would apply on here
    * */
    getNonPathInactiveSVGAttrs: function( canvasChannel ) {

        return canvasChannel.request( 'getAttributesToApplyToShapeEl', this.parentNote, false, this ); // don't need subtype

    },

    getPathToRenderFromModel: function(scale) {
        return Raphael.fn.getPathFromPtsArray(
            this.getAdjustedPointsArray(scale), this.shouldCloseElementPath()
        );
    },
    /*
    * TODO:
    *  - will want a current color when the user is able to change it
    *  - subclass into find and redact
    *  - could update points of all shapes on move/drag as well
    * seeThroughFill: normalize hex color values to lowercase just in case
    * subtype: values map to Java enums; it's ignored in the application but we need to write for FDD client (and should have needed for this app)
    * */
    getAttrsToPersist: function(scale) {

        var isFindAndRedact = this.isFindAndRedactShape;

        return {

            points: !isFindAndRedact
                ? this._getPointsFromEl( scale )
                : this.get('points'), // points set prior to render and updated on move/resize -- don't get from el

            seeThroughFill: this.getZoneColor().toLowerCase(),

            subtype: !isFindAndRedact
                ? this.uiModel.raphaelEl().pathIsRect() ? 'RECTANGLE' : 'POLYGON'
                : 'RECTANGLE' // for now, if we don't let user modify, always rectangle

        };

    },
    /*
    * Used to draw and return new raphael el from the existing points in the model.
    * Scale, adjustment, and rotation taken into account.
    * Called from renderFromModel.
    * Note: for now pg is the fullPage model.
    * */
    getAdjustedPointsArray: function(scale) {

        return this.pageModel.isCold()
            ? this._getColdPageAdjustedPointsArray(scale)
            : this._getImagePgAdjustedPtsArray(scale);
    },

    // Note: find and redact points are stored at the in 1/10 mm
    // at the FDD's dpi, not the OCR engine, so conversion to pixels from 1/10th mm
    // should always use FDD's DPI from the page model.
    // note: not called for COLD pages but check in place
    // TODO: maybe put isCold into adjustPtsFromDbToViewer ?
    _getImagePgAdjustedPtsArray: function(scale) {

        var pg = this.pageModel,
            isColdPage = pg.isCold();

        return ShapeUtils.adjustPtsFromDbToViewer(
            this.get('points'),
            scale,
            isColdPage ? null : pg.getDPI(),
            pg.get('rotation'),
            isColdPage ? null : pg.getOriginalCenter()

        );

    },
    /*
    * Always a rectangle, no rotation, conversion constant, polygon redactions.
    * Cover text coordinate values to pixel values.
    * TODO: if the point overlap a fraction of a coordinate, need to extend the coordinate ...
    * */
    _getColdPageAdjustedPointsArray: function(scale) {

        var pts = this.get('points'),
            o = this.pageModel.get('overlay');

        return _.map(pts, function(p) {
            return  {
                x: (p.x / o.cpi  * 96) * scale,
                y: (p.y / o.lpi * 96) * scale
            };
        });

    },
    /**
     * Note: always at FDD's DPI ( vs OCR engine's for find and redact shapes.
     * If/when we move to storing the coordinates live may no longer be necessary.
     */
    _getPointsFromEl: function(scale, pts) {

        var pg = this.pageModel,
            isCold = pg.isCold();

        return ShapeUtils.adjustPtsFromViewerToDb(
            !pts ? this.uiModel.raphaelEl().getPathCoordinates() : pts,
            isCold,
            scale,
            isCold ? null : pg.getDPI(),
            pg.get('rotation'),
            isCold ? null : pg.getOrigRotatedCenter(), // TODO: have diff fn's to call if page has rotation, and pass in accordingly ... (?) -- or pass 0 if no rotation ...
            isCold  // break up cold ?
                ? pg.get('overlay')
                : undefined
        );

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/coordinate.js
 ** module id = 253
 ** module chunks = 0
 **/